import { render, staticRenderFns } from "./CustomImageViewer.vue?vue&type=template&id=a77f3ff4&scoped=true&"
import script from "./CustomImageViewer.vue?vue&type=script&lang=js&"
export * from "./CustomImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./CustomImageViewer.vue?vue&type=style&index=0&id=a77f3ff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77f3ff4",
  null
  
)

export default component.exports